import React from 'react';

import LegalPolicyPage from './LegalPolicyPage';

interface CookiePolicyPageProps {
  onNavigate?: (view: string) => void;
}

const CookiePolicyPage: React.FC<CookiePolicyPageProps> = ({ onNavigate }) => (
  <LegalPolicyPage policyId="cookie" onNavigate={onNavigate ?? (() => {})} />
);

export default CookiePolicyPage;
